export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_16-a63fed18a168f995a4815ab52ecc459c.jpg";